/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2025 HG Digital/Setera
 * Todos os direitos reservados.
 * 
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 15-05-2025 16:50:21
 * Autor     : Diego Fabiano Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

/**
 * Model para o payload de execução de comando (executeCommand)
 */
export class CommandExecutionRequest {
  /**
   * Mapeamento de UUID do campo para valor informado pelo usuário
   */
  fieldValues: { [uuid: string]: string };

  /**
   * Lista de IDs de terminais para envio do comando
   */
  terminalIds: number[];

  /**
   * ID do usuário que está criando o comando
   */
  idUsuarioCriacao: number;

  constructor(fieldValues: { [uuid: string]: string }, terminalIds: number[], idUsuarioCriacao: number) {
    this.fieldValues = fieldValues;
    this.terminalIds = terminalIds;
    this.idUsuarioCriacao = idUsuarioCriacao;
  }
} 